import Vue from 'vue'
import App from './App.vue'
import store from './store';
import 'amfe-flexible/index.js';
import '@vant/touch-emulator';
import Vant from 'vant';
import 'vant/lib/index.css';
import VConsole from 'vconsole';
import http from '@/utils/axios';
import 'animate.css';
import '@/assets/less/index.less';
import './directive/index.js';
import gioFun from '@/utils/gio';
import loading from '@/components/loading/loading.js';
import miniCode from '@/components/miniCode/index.js';
import router from './router';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import VueKeepScrollPosition from 'vue-keep-scroll-position';
import VueTouch from 'vue-touch'
import '@/components/filter/index.js'
import publicFunc from "@/utils/publicFunc.js"
import CNavbar from './components/c-navbar';
// import './assets/css/richTextLineHeight.css'    //隐私政策动态配置,样式引用注释
Vue.config.ignoredElements = ['wx-open-launch-weapp'];

Vue.use(CNavbar);
Vue.use(VueAwesomeSwiper)
Vue.use(VueKeepScrollPosition)
Vue.use(loading)
Vue.use(miniCode)
Vue.use(VueTouch, { name: 'v-touch' })

Vue.prototype.http = http;
Vue.prototype.gioFun = gioFun;
Vue.prototype.$publicFunc = publicFunc;

const wx = window.wx
const {configDebugger} = extendBeegoConfig;
Vue.prototype.$wx = wx
if(process.env.VUE_APP_CURRENTMODE !== 'prod'){
    new VConsole(); 
}
// if (process.env.VUE_APP_CURRENTMODE !== 'prod') {
   
//     if(configUrl === process.env.VUE_APP_BASEURL){
        
//     }
   
// }




Vue.config.productionTip = false;
Vue.use(Vant);
//路由权限控制:检测获取皮肤数据情况
import permissionRouter from './permission'
permissionRouter(Vue)

window.sendAmaoLocation = function() {};
new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
